import React from 'react';

import { useOutsideClick } from '@hooks';

import { OutsideClickListenerProps } from './OutsideClickListener.types';

export const OutsideClickListener = ({
  action,
  children,
}: OutsideClickListenerProps) => {
  const containerRef = useOutsideClick(action);

  return <div ref={containerRef}>{children}</div>;
};
